import * as React from 'react';

import { StatsigProvider } from '@coursera-web/statsig';
import { compose } from 'recompose';

import Retracked from 'js/app/retracked';

import SimpleCourseraMetatags from 'bundles/seo/components/SimpleCourseraMetatags';
import withMarketingConsent from 'bundles/user-consent/components/withMarketingConsent';

import 'css!../__styles__/index';

type Props = {
  children?: React.ReactNode;
};

const Onboarding2022App = ({ children }: Props) => {
  return (
    <StatsigProvider>
      <div className="rc-Onboarding2022App">
        {children}
        <SimpleCourseraMetatags />
      </div>
    </StatsigProvider>
  );
};

export default compose<{}, React.PropsWithChildren<{}>>(
  Retracked.createTrackedContainer(() => {
    return {
      namespace: {
        app: 'onboarding_2022',
        page: 'onboarding_2022',
      },
    };
  }),
  withMarketingConsent
)(Onboarding2022App);
